const PRODUCT_TAB = {
  INVESTMENT: 'INVESTMENT',
  WORK: 'WORK',
} as const

type PRODUCT_TAB_TYPE = (typeof PRODUCT_TAB)[keyof typeof PRODUCT_TAB]

export { PRODUCT_TAB }

export type { PRODUCT_TAB_TYPE }
